import React, { useEffect, useState } from "react";
import {
    DatePicker,
    Input,
    Form,
    Select,
    Button,
    Badge,
    Card,
    Col,
    Row,
    Tag,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import PageHeader from "../../components/PageHeader/PageHeader";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
    addCalendar,
    deleteCalendar,
    getAllCalendar,
    updateCalendar,
} from "../../redux/actions/Calendar.action";
import { ReadCookie } from "../../utils/readCookie";
import Loader from "react-loader-spinner";
import Swal from "sweetalert2";
import { TabTitle } from "../../utils/GeneralFunction";

const { Option } = Select;

const CalenderForm = () => {
    TabTitle("Add Calendar")
    const [form] = Form.useForm();
    const { calendar, user } = useSelector((state) => state);
    const dispatch = useDispatch();
    const token = ReadCookie("token");
    const user_id = ReadCookie("id");
    const user_name = ReadCookie("name");
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState(null); // Edit Mode
    const [allEvents, setAllEvents] = useState([]);
    const [events, setEvents] = useState([{ event: "", status: "Medium", loginId: user_name, userId: user_id }]);


    const init = () => {
        setLoading(true)
        dispatch(
            getAllCalendar(token, { from_date: "2018-01-01", to_date: "2050-01-01" })
        ).then((res) => {

            if (res.type === "GET_ALL_CALENDAR_SUCCESS") {
                setAllEvents(
                    res.payload.data
                );
                setLoading(false)
            }
        });
    };

    const onFinish = (values) => {

        if (mode === "Edit") {
            dispatch(updateCalendar(token, form.getFieldValue())).then((res) => {
                let date = res?.payload?.data?.date
                if (res.type === "UPDATE_CALENDAR_SUCCESS") {
                    setAllEvents(prev => {
                        const exists = prev.some(e => e.date === date);
                        if (exists) {
                            return prev.map(item =>
                                item.date === date ? res?.payload?.data : item
                            );
                        }
                    });
                }
            });
        } else {
            dispatch(addCalendar(token, form.getFieldValue()));
        }
        setEvents([{ event: "", status: "Medium", loginId: "", userId: "" }]);
        // form.resetFields();
        setMode(null);
        init();
    };



    const handleEdit = (item) => {
        setMode("Edit");
        setEvents([...item.events]);
        form.setFieldsValue({ eventDate: moment(item.date, "YYYY-MM-DD"), events: item.events });
    };


    const handleDelete = (date) => {
        Swal.fire({
            title: `Do you want to Delete the ${moment(date).format("MM-DD-YYYY")} Events?`,
            // showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Delete",
            customClass: {
                title: 'swal-title-custom',

            }
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteCalendar(token, date)).then((res) => {
                    if (res.type === "DELETE_CALENDAR_SUCCESS") {
                        init();
                        setAllEvents(allEvents.filter((v) => v.date !== date));
                        Swal.fire(res.payload.data, "", "success");
                    }
                })
            }
        });
    };

    useEffect(() => {
        init();
    }, [dispatch]);

    useEffect(() => {
        form.setFieldsValue({ events });
    }, [events, form]);

    return (
        <div className="styleContainer">
            <PageHeader title={"Add/Edit Calendar Events"} />
            <Form form={form} onFinish={onFinish}
                initialValues={{
                    eventDate: moment(), // Set default date
                    sno: null
                }}
                layout="vertical">
                <div
                    style={{
                        width: "70%",
                        border: "1px solid #e5e5e5",
                        margin: "0 auto",
                        padding: 10,
                        marginTop: 10
                    }}
                >
                    {/* Event Date */}
                    <Form.Item
                        name="eventDate"
                        label="Event Date :"
                        rules={[{ required: true, message: "Event Date is required!" }]}
                    >
                        <DatePicker
                            size="small"
                            format="MM-DD-YYYY"
                            className="dateInput customInputs"
                        // value={eventDate ? moment(eventDate) : null}
                        // onChange={(date) => {
                        //     setEventDate(date);
                        //     form.setFieldsValue({ eventDate: date });
                        // }}
                        />
                    </Form.Item>

                    {/* Events List */}
                    <Form.List name="events">
                        {(fields, { add, remove }) => (
                            <>
                                {events.map((item, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            gap: 5,
                                            marginTop: 10,
                                            alignItems: "center",
                                        }}
                                    >
                                        <div>{index + 1}.</div>
                                        {/* Event Input */}
                                        <Form.Item
                                            name={[index, "event"]}  // Use index instead of array path
                                            rules={[{ required: true, message: "Event is required!" }]}
                                            style={{ flex: 1 }}
                                        >
                                            <Input
                                                placeholder="Enter Event"
                                                onChange={(e) => {
                                                    const updatedEvents = [...events];
                                                    updatedEvents[index].event = e.target.value;
                                                    setEvents(updatedEvents);
                                                    form.setFieldsValue({ events: updatedEvents }); // Update form fields
                                                }}
                                            />
                                        </Form.Item>

                                        {/* Status Select */}
                                        <Form.Item
                                            name={[index, "status"]}
                                            rules={[{ required: true, message: "Status is required!" }]}
                                        >
                                            <Select
                                                style={{ width: "150px" }}
                                                onChange={(value) => {
                                                    const updatedEvents = [...events];
                                                    updatedEvents[index].status = value;
                                                    setEvents(updatedEvents);
                                                    form.setFieldsValue({ events: updatedEvents }); // Update form fields
                                                }}
                                            >
                                                <Option value="High">
                                                    <Badge status="error" text="High" />
                                                </Option>
                                                <Option value="Medium">
                                                    <Badge status="warning" text="Medium" />
                                                </Option>
                                                <Option value="Low">
                                                    <Badge status="success" text="Low" />
                                                </Option>
                                            </Select>
                                        </Form.Item>

                                        {/* Delete Event */}
                                        {index > 0 && (
                                            <DeleteOutlined
                                                style={{ cursor: "pointer", color: "red" }}
                                                onClick={() => {
                                                    const updatedEvents = events.filter((_, i) => i !== index);
                                                    setEvents(updatedEvents);
                                                    form.setFieldsValue({ events: updatedEvents });
                                                }}
                                            />
                                        )}

                                    </div>
                                ))}

                                {/* Add New Event Button */}
                                <Button
                                    type="dashed"
                                    onClick={() => {
                                        const newEvents = [...events, { event: "", status: "Medium", loginId: user_name, userId: user_id }];
                                        setEvents(newEvents);
                                        form.setFieldsValue({ events: newEvents });
                                    }}
                                >
                                    Add Another Event
                                </Button>
                            </>
                        )}
                    </Form.List>


                    {/* Submit Button */}
                    <Form.Item style={{ textAlign: "right", marginTop: 10 }}>
                        <Button type="primary" htmlType="submit">
                            {mode === "Edit" ? "Update" : "Save"}
                        </Button>
                    </Form.Item>
                </div>
            </Form>

            {/* Loader */}
            {loading && (
                <div className="loaderDiv">
                    <Loader type="Grid" color="#212121" height={40} width={40} />
                </div>
            )}

            {/* Display Calendar Events */}
            <Row gutter={16} style={{ marginTop: 20 }}>
                {allEvents.map((item, idx) => (
                    <Col key={idx} xs={24} sm={6} md={6} lg={6} style={{ marginTop: 10 }}>
                        <Card
                            style={{ height: 250, overflowY: "auto" }}
                            title={`Date : ${moment(item.date).format("MM-DD-YYYY")}`}
                        >
                            <div style={{ display: "flex", justifyContent: "end", gap: 20 }}>
                                <EditOutlined
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEdit(item)}
                                />
                                <DeleteOutlined
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDelete(item.date)}
                                />
                            </div>
                            {item?.events?.map((val, i) => (
                                <div key={i} style={{ marginTop: 10 }}>
                                    <div
                                        style={{
                                            border: "1px solid gray",
                                            // borderRadius: 10,
                                            padding: 10,
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <div>{i + 1}. {val.event}</div>
                                        <Tag
                                            color={
                                                val.status === "High"
                                                    ? "error"
                                                    : val.status === "Medium"
                                                        ? "warning"
                                                        : "success"
                                            }
                                        >
                                            {val.status}
                                        </Tag>
                                    </div>
                                </div>
                            ))}
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default CalenderForm;
